exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".libs__smooth__29Fwz {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.libs__sansSerif__1_5RW {\n\n    font-family: Lato, Trebuchet MS, Arial, sans-serif;\n}\n\n.libs__normalWeight__12pVo {\n    font-weight: normal;\n}\n\n.libs__bold__3--5n {\n    font-weight: bold;\n}\n\n.libs__normalHeight__2ocjZ {\n    line-height: 1.5em;\n}\n\n.libs__mini__3yIpb {\n\n    font-size: 11px;\n}\n\n.libs__small__mmAVr {\n\n    font-size: 16px;\n}\n\n.libs__medium__1lRzg {\n\n    font-size: 18px;\n}\n\n.libs__large__CrvrB {\n\n    font-size: 22px;\n}\n\n.libs__extraLarge__19h7h {\n\n  font-size: 28px;\n}\n\n.libs__jumbo__29lUN {\n\n    font-size: 36px;\n}\n\n.libs__truncate__3Vzi3 {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"smooth": "libs__smooth__29Fwz",
	"sansSerif": "libs__sansSerif__1_5RW libs__smooth__29Fwz",
	"normalWeight": "libs__normalWeight__12pVo",
	"bold": "libs__bold__3--5n",
	"normalHeight": "libs__normalHeight__2ocjZ",
	"mini": "libs__mini__3yIpb libs__normalHeight__2ocjZ",
	"small": "libs__small__mmAVr libs__normalHeight__2ocjZ",
	"medium": "libs__medium__1lRzg libs__normalHeight__2ocjZ",
	"large": "libs__large__CrvrB libs__normalHeight__2ocjZ",
	"extraLarge": "libs__extraLarge__19h7h libs__normalHeight__2ocjZ",
	"jumbo": "libs__jumbo__29lUN libs__normalHeight__2ocjZ",
	"truncate": "libs__truncate__3Vzi3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[folder]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib!./client/src/style/libs/typography.css
// module id = HX71
// module chunks = 0